import { isDefined } from './type';

export function randomInt(max: number) {
  return Math.floor(Math.random() * Math.floor(max));
}

export function uuid() {
  return Math.random().toString(36).slice(2);
}

export function numberWithinRangeInclusive(
  value: number,
  between: { min: number; max: number }
) {
  if (value < between.min) return between.min;
  if (value > between.max) return between.max;

  return value;
}

export function range(
  start: number,
  stop?: number,
  step?: number
): Array<number> {
  if (!isDefined(stop)) return range(0, start);

  if (!isDefined(step)) return range(start, stop, stop >= start ? 1 : -1);

  return Array(Math.ceil((stop - start) / step))
    .fill(null)
    .map((_, i) => i * (step || 1) + start);
}
